"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.components = void 0;
var _semantic_colors = require("./colors/_semantic_colors");
var _colors_dark = require("./colors/_colors_dark");
var _buttons = require("./_buttons");
var _forms = require("./_forms");
var _colors_light = require("./colors/_colors_light");
var _colors_vis = require("./colors/_colors_vis");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
var component_colors = {
  badgeBackground: _colors_light.background_colors.backgroundLightText,
  badgeBackgroundSubdued: _colors_light.background_colors.backgroundLightText,
  badgeBorderColorHollow: _colors_light.border_colors.borderBasePlain,
  badgeIconButtonBackgroundHover: _colors_light.background_colors.backgroundBaseInteractiveHover,
  breadcrumbsApplicationBackground: _colors_light.background_colors.backgroundLightText,
  breadcrumbsApplicationColor: _colors_light.text_colors.textSubdued,
  bottomBarBackground: _semantic_colors.SEMANTIC_COLORS.plainDark,
  buttonGroupBackgroundDisabledSelected: _colors_light.background_colors.backgroundBaseFormsControlDisabled,
  buttonGroupBorderColor: _colors_light.border_colors.borderBasePlain,
  buttonGroupBorderColorSelected: _colors_light.border_colors.borderBasePlain,
  buttonGroupFocusColor: _colors_light.brand_text_colors.textPrimary,
  codeBackground: _colors_light.background_colors.backgroundBaseHighlighted,
  codeBackgroundSelected: 'inherit',
  codeColor: _colors_light.text_colors.textParagraph,
  codeInlineColor: _colors_vis.colorVis.euiColorVisAsTextLight6,
  codeCommentColor: _colors_light.text_colors.textSubdued,
  codeSelectorColor: 'inherit',
  codeStringColor: _colors_vis.colorVis.euiColorVisAsTextLight2,
  codeTagColor: _colors_vis.colorVis.euiColorVisAsTextLight1,
  codeNameColor: _colors_vis.colorVis.euiColorVisAsTextLight1,
  codeNumberColor: _colors_vis.colorVis.euiColorVisAsTextLight0,
  codeInlineCodeKeywordColor: _colors_vis.colorVis.euiColorVisAsTextLight6,
  codeKeywordColor: _colors_vis.colorVis.euiColorVisAsTextLight1,
  codeFunctionTitleColor: 'inherit',
  codeTypeColor: _colors_vis.colorVis.euiColorVisAsTextLight1,
  codeAttributeColor: 'inherit',
  codeSymbolColor: _colors_vis.colorVis.euiColorVisAsTextLight3,
  codeParamsColor: 'inherit',
  codeMetaColor: _colors_light.text_colors.textSubdued,
  codeTitleColor: _colors_vis.colorVis.euiColorVisAsTextLight4,
  codeSectionColor: _colors_vis.colorVis.euiColorVisAsTextLight3,
  codeAdditionColor: _colors_vis.colorVis.euiColorVisAsTextLight0,
  codeDeletionColor: _colors_vis.colorVis.euiColorVisAsTextLight3,
  codeSelectorClassColor: 'inherit',
  codeSelectorIdColor: 'inherit',
  collapsibleNavGroupBackground: _colors_light.background_colors.backgroundBaseSubdued,
  collapsibleNavGroupBackgroundDark: _colors_dark.dark_background_colors.backgroundBaseSubdued,
  dataGridBorderColor: _colors_light.border_colors.borderBaseSubdued,
  dataGridVerticalLineBorderColor: _colors_light.border_colors.borderBaseSubdued,
  dataGridRowBackgroundStriped: _colors_light.background_colors.backgroundBaseSubdued,
  dataGridRowBackgroundHover: _colors_light.background_colors.backgroundBaseInteractiveHover,
  dataGridRowBackgroundSelect: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  dragDropDraggingBackground: _colors_light.background_colors.backgroundBaseSuccess,
  dragDropDraggingOverBackground: _colors_light.background_colors.backgroundLightSuccess,
  filterSelectItemBackgroundFocusDisabled: _colors_light.background_colors.backgroundBaseDisabled,
  flyoutFooterBackground: _colors_light.background_colors.backgroundBaseHighlighted,
  flyoutCloseButtonInsideBackground: _colors_light.background_colors.backgroundBasePlain,
  headerBackground: _colors_light.background_colors.backgroundBasePlain,
  headerDarkBackground: _colors_dark.dark_background_colors.backgroundBasePlain,
  headerDarkSearchBorderColor: _colors_dark.dark_border_colors.borderBasePlain,
  headerDarkSectionItemBackgroundFocus: _colors_dark.dark_background_colors.backgroundBasePrimary,
  keyPadMenuItemBackgroundDisabledSelect: _colors_light.background_colors.backgroundBaseDisabled,
  listGroupItemBackgroundPrimaryActive: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  listGroupItemBackgroundSubduedActive: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  listGroupItemBackgroundHover: _colors_light.background_colors.backgroundBaseInteractiveHover,
  listGroupItemBackgroundPrimaryHover: _colors_light.background_colors.backgroundBaseInteractiveHover,
  loadingSpinnerBorder: _colors_light.border_colors.borderBasePlain,
  loadingSpinnerHighlight: _colors_light.border_colors.borderStrongPrimary,
  loadingChartMonoBackground0: _semantic_colors.SEMANTIC_COLORS.shade20,
  loadingChartMonoBackground1: _semantic_colors.SEMANTIC_COLORS.shade30,
  loadingChartMonoBackground2: _semantic_colors.SEMANTIC_COLORS.shade40,
  loadingChartMonoBackground3: _semantic_colors.SEMANTIC_COLORS.shade50,
  markBackground: _colors_light.background_colors.backgroundLightPrimary,
  markdownFormatTableBorderColor: _colors_light.border_colors.borderBasePlain,
  overlayMaskBackground: _colors_light.background_colors.backgroundBaseInteractiveOverlay,
  overlayMaskBackgroundHighContrast: "rgba(".concat(_semantic_colors.SEMANTIC_COLORS.shade140RGB, ", 0.9)"),
  popoverPanelBackground: _colors_light.background_colors.backgroundBasePlain,
  popoverFooterBorderColor: _colors_light.border_colors.borderBaseSubdued,
  scrollbarTrackColor: _semantic_colors.SEMANTIC_COLORS.shade15,
  sideNavItemEmphasizedBackground: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  selectableListItemBorderColor: _colors_light.border_colors.borderBaseSubdued,
  skeletonBackgroundSkeletonMiddleHighContrast: "rgba(".concat(_semantic_colors.SEMANTIC_COLORS.shade100RGB, ", 0.04)"),
  superDatePickerBackgroundSuccees: _colors_light.background_colors.backgroundBaseSuccess,
  switchBackgroundOn: _colors_light.background_colors.backgroundFilledPrimary,
  switchBackgroundOff: _colors_light.background_colors.backgroundFilledText,
  switchUncompressedBackgroundDisabled: _colors_light.background_colors.backgroundBaseFormsControlDisabled,
  switchCompressedBackgroundDisabled: _colors_light.background_colors.backgroundBaseFormsControlDisabled,
  switchMiniBackgroundDisabled: _colors_light.background_colors.backgroundBaseFormsControlDisabled,
  switchThumbBackgroundDisabled: _colors_light.background_colors.backgroundBasePlain,
  switchThumbBorderOn: _colors_light.background_colors.backgroundFilledPrimary,
  switchThumbBorderOff: _colors_light.background_colors.backgroundFilledText,
  switchIconDisabled: _forms.forms.LIGHT.iconDisabled,
  tableRowBackgroundHover: _colors_light.background_colors.backgroundBaseInteractiveHover,
  tableRowBackgroundSelected: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  tableRowBackgroundSelectedHover: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  tableRowInteractiveBackgroundHover: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  tableRowInteractiveBackgroundFocus: _colors_light.background_colors.backgroundBaseInteractiveSelect,
  tableCellSortableIconColor: _colors_light.background_colors.backgroundFilledText,
  tooltipBackground: _colors_dark.dark_background_colors.backgroundBaseSubdued,
  tooltipBorder: _colors_dark.dark_border_colors.borderBaseSubdued,
  tooltipBorderFloating: _colors_light.border_colors.borderBaseFloating,
  tourFooterBackground: _colors_light.background_colors.backgroundBaseHighlighted,
  treeViewItemBackgroundHover: _colors_light.background_colors.backgroundBaseInteractiveHover
};
var components = exports.components = {
  buttons: _buttons.buttons,
  forms: _forms.forms,
  LIGHT: component_colors,
  DARK: _objectSpread(_objectSpread({}, component_colors), {}, {
    badgeBackground: _colors_dark.dark_background_colors.backgroundLightText,
    badgeBackgroundSubdued: _colors_dark.dark_background_colors.backgroundLightText,
    badgeBorderColorHollow: _colors_dark.dark_border_colors.borderBasePlain,
    badgeIconButtonBackgroundHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    breadcrumbsApplicationBackground: _colors_dark.dark_background_colors.backgroundLightText,
    breadcrumbsApplicationColor: _colors_dark.dark_text_colors.textSubdued,
    buttonGroupBackgroundDisabledSelected: _colors_dark.dark_background_colors.backgroundBaseFormsControlDisabled,
    buttonGroupBorderColor: _colors_dark.dark_border_colors.borderBasePlain,
    buttonGroupBorderColorSelected: _colors_dark.dark_border_colors.borderBasePlain,
    buttonGroupFocusColor: _colors_dark.dark_brand_text_colors.textPrimary,
    codeBackground: _colors_dark.dark_background_colors.backgroundBaseHighlighted,
    codeBackgroundSelected: 'inherit',
    codeColor: _colors_dark.dark_text_colors.textParagraph,
    codeInlineColor: _colors_vis.colorVis.euiColorVisAsTextDark6,
    codeCommentColor: _colors_dark.dark_text_colors.textSubdued,
    codeSelectorColor: 'inherit',
    codeStringColor: _colors_vis.colorVis.euiColorVisAsTextDark2,
    codeTagColor: _colors_vis.colorVis.euiColorVisAsTextDark1,
    codeNameColor: _colors_vis.colorVis.euiColorVisAsTextDark1,
    codeNumberColor: _colors_vis.colorVis.euiColorVisAsTextDark0,
    codeKeywordColor: _colors_vis.colorVis.euiColorVisAsTextDark6,
    codeFunctionTitleColor: 'inherit',
    codeTypeColor: _colors_vis.colorVis.euiColorVisAsTextDark1,
    codeAttributeColor: 'inherit',
    codeSymbolColor: _colors_vis.colorVis.euiColorVisAsTextDark3,
    codeParamsColor: 'inherit',
    codeMetaColor: _colors_dark.dark_text_colors.textSubdued,
    codeTitleColor: _colors_vis.colorVis.euiColorVisAsTextDark4,
    codeSectionColor: _colors_vis.colorVis.euiColorVisAsTextDark3,
    codeAdditionColor: _colors_vis.colorVis.euiColorVisAsTextDark0,
    codeDeletionColor: _colors_vis.colorVis.euiColorVisAsTextDark3,
    codeSelectorClassColor: 'inherit',
    codeSelectorIdColor: 'inherit',
    collapsibleNavGroupBackground: _colors_dark.dark_background_colors.backgroundBaseSubdued,
    collapsibleNavGroupBackgroundDark: _colors_dark.dark_background_colors.backgroundBaseSubdued,
    dataGridBorderColor: _colors_dark.dark_border_colors.borderBaseSubdued,
    dataGridVerticalLineBorderColor: _colors_dark.dark_border_colors.borderBaseSubdued,
    dataGridRowBackgroundStriped: _colors_dark.dark_background_colors.backgroundBaseSubdued,
    dataGridRowBackgroundHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    dataGridRowBackgroundSelect: _colors_dark.dark_background_colors.backgroundBaseInteractiveSelect,
    dragDropDraggingBackground: _colors_dark.dark_background_colors.backgroundBaseSuccess,
    dragDropDraggingOverBackground: _colors_dark.dark_background_colors.backgroundLightSuccess,
    filterSelectItemBackgroundFocusDisabled: _colors_dark.dark_background_colors.backgroundBaseDisabled,
    flyoutFooterBackground: _colors_dark.dark_background_colors.backgroundBaseHighlighted,
    flyoutCloseButtonInsideBackground: _colors_dark.dark_background_colors.backgroundBasePlain,
    headerBackground: _colors_dark.dark_background_colors.backgroundBasePlain,
    keyPadMenuItemBackgroundDisabledSelect: _colors_dark.dark_background_colors.backgroundBaseDisabled,
    listGroupItemBackgroundPrimaryActive: _colors_dark.dark_background_colors.backgroundBaseInteractiveSelect,
    listGroupItemBackgroundSubduedActive: _colors_dark.dark_background_colors.backgroundBaseInteractiveSelect,
    listGroupItemBackgroundHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    listGroupItemBackgroundPrimaryHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    loadingSpinnerBorder: _colors_dark.dark_border_colors.borderBasePlain,
    loadingSpinnerHighlight: _colors_dark.dark_border_colors.borderStrongPrimary,
    loadingChartMonoBackground0: _semantic_colors.SEMANTIC_COLORS.shade110,
    loadingChartMonoBackground1: _semantic_colors.SEMANTIC_COLORS.shade100,
    loadingChartMonoBackground2: _semantic_colors.SEMANTIC_COLORS.shade90,
    loadingChartMonoBackground3: _semantic_colors.SEMANTIC_COLORS.shade80,
    markBackground: _colors_dark.dark_background_colors.backgroundLightPrimary,
    markdownFormatTableBorderColor: _colors_dark.dark_border_colors.borderBasePlain,
    overlayMaskBackground: _colors_dark.dark_background_colors.backgroundBaseInteractiveOverlay,
    overlayMaskBackgroundHighContrast: "rgba(".concat(_semantic_colors.SEMANTIC_COLORS.shade140RGB, ", 0.9)"),
    popoverPanelBackground: _colors_dark.dark_background_colors.backgroundBasePlain,
    popoverFooterBorderColor: _colors_dark.dark_border_colors.borderBaseSubdued,
    scrollbarTrackColor: _semantic_colors.SEMANTIC_COLORS.shade145,
    sideNavItemEmphasizedBackground: _colors_dark.dark_background_colors.backgroundBaseInteractiveSelect,
    selectableListItemBorderColor: _colors_dark.dark_border_colors.borderBaseSubdued,
    skeletonBackgroundSkeletonMiddleHighContrast: "rgba(".concat(_semantic_colors.SEMANTIC_COLORS.plainLightRGB, ", 0.3)"),
    switchBackgroundOn: _colors_dark.dark_background_colors.backgroundFilledPrimary,
    switchBackgroundOff: _colors_dark.dark_background_colors.backgroundFilledText,
    switchUncompressedBackgroundDisabled: _colors_dark.dark_background_colors.backgroundBaseFormsControlDisabled,
    switchCompressedBackgroundDisabled: _colors_dark.dark_background_colors.backgroundBaseFormsControlDisabled,
    switchMiniBackgroundDisabled: _colors_dark.dark_background_colors.backgroundBaseFormsControlDisabled,
    switchThumbBackgroundDisabled: _colors_dark.dark_background_colors.backgroundBasePlain,
    switchThumbBorderOn: _colors_dark.dark_background_colors.backgroundFilledPrimary,
    switchThumbBorderOff: _colors_dark.dark_background_colors.backgroundFilledText,
    switchIconDisabled: _forms.forms.DARK.iconDisabled,
    superDatePickerBackgroundSuccees: _colors_dark.dark_background_colors.backgroundBaseSuccess,
    tableRowBackgroundHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    tableRowBackgroundSelected: _colors_dark.dark_background_colors.backgroundBaseInteractiveSelect,
    tableRowBackgroundSelectedHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveSelect,
    tableRowInteractiveBackgroundHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    tableRowInteractiveBackgroundFocus: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover,
    tableCellSortableIconColor: _colors_dark.dark_background_colors.backgroundFilledText,
    tooltipBorderFloating: _colors_dark.dark_border_colors.borderBaseFloating,
    tourFooterBackground: _colors_dark.dark_background_colors.backgroundBaseHighlighted,
    treeViewItemBackgroundHover: _colors_dark.dark_background_colors.backgroundBaseInteractiveHover
  })
};
//# sourceMappingURL=_components.js.map